import { render } from "./AboutInfoBlock.vue?vue&type=template&id=4be222bd"
import script from "./AboutInfoBlock.vue?vue&type=script&lang=js"
export * from "./AboutInfoBlock.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__